import { render, staticRenderFns } from "./LiveRoom.vue?vue&type=template&id=536ce8ba&scoped=true&"
import script from "./LiveRoom.vue?vue&type=script&lang=js&"
export * from "./LiveRoom.vue?vue&type=script&lang=js&"
import style0 from "./LiveRoom.vue?vue&type=style&index=0&id=536ce8ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536ce8ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
